import React from 'react';

const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Mesaj / DM': 'bg-violet-50 text-violet-700 border-violet-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export default function KerametIlicasiAgustos2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* KERAMET ILICASI — ₺70,000 — Ağustos 2026                               */}
      {/* Meta ₺38,000 (Awareness + Engagement + Video Views) — trafik/mesaj YOK  */}
      {/* Google ₺29,000 (YouTube ₺19K + Search ₺10K) · TikTok ₺3,000 (test)     */}
      {/* Hesapta geçmiş veri YOK → tüm birim maliyetler pazar benchmark'ıdır    */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-teal-700 px-3.5 py-2">
              <span className="text-white font-bold tracking-wide text-sm">KERAMET</span>
              <span className="block text-teal-200 text-[9px] tracking-[0.2em] uppercase">Ilıcası</span>
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">KERAMET ILICASI — Ağustos 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Günübirlik Termal Tesis • Meta Ads (Awareness + Engagement + Video Views) • Google Ads (YouTube + Search) • TikTok (Video Views)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Ağustos 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺70,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* İlk ay uyarısı */}
          <div className="mb-6 p-4 rounded-xl bg-rose-50 border border-rose-200">
            <p className="text-xs font-semibold text-rose-800 mb-1">İlk Ay — Kalibrasyon Dönemi</p>
            <p className="text-[11px] text-rose-700 leading-relaxed">
              Keramet Ilıcası için platformda <strong>hiç geçmiş reklam verisi bulunmuyor</strong>. Aşağıdaki CPM, CPV ve CPC değerlerinin tamamı
              Türkiye pazarındaki turizm / günübirlik tesis benchmark'larıdır; hesabın kendi verisinden türetilmemiştir.
              Bu nedenle Ağustos, <strong>öğrenme ve kalibrasyon ayı</strong> olarak kurgulanmıştır: bütçe geniş bir tabana yayılır,
              ay sonunda gerçekleşen birim maliyetlerle Eylül planı yeniden kurulur. İlk ayın hedefi maksimum ziyaret değil,
              <strong> hangi kitlenin ve hangi mesajın çalıştığını ölçmektir</strong>.
            </p>
          </div>

          {/* Tesis künyesi */}
          <div className="mb-6 rounded-xl border border-teal-200 overflow-hidden">
            <div className="bg-teal-50 px-4 py-2.5 text-xs font-semibold text-teal-900">Tesis Künyesi — Hedefleme Girdileri</div>
            <div className="p-5 grid grid-cols-2 md:grid-cols-4 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-0.5">Konum</p>
                <p className="leading-relaxed">Orhangazi / Bursa — İznik yolu üzeri</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-0.5">Mesafe</p>
                <p className="leading-relaxed">Orhangazi 16 km · Yalova 36 km · Bursa 63 km</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-0.5">Ürün</p>
                <p className="leading-relaxed">Açık havuz, doğal termal su (~30-34°C), sülfürlü</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-0.5">Kullanım</p>
                <p className="leading-relaxed">Günübirlik giriş; otopark, soyunma, piknik alanı</p>
              </div>
            </div>
            <div className="px-4 py-2.5 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-800">
              Bu künye <strong>kamuya açık kaynaklardan derlenmiştir</strong> ve yayına çıkmadan önce işletme tarafından doğrulanmalıdır.
              Giriş ücreti, çalışma saatleri, kapasite ve kampanya koşulları netleştiğinde kreatif mesajları buna göre güncellenecektir.
            </div>
          </div>

          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Ağustos Odağı — Bilinirlik Kurma &amp; Arama Talebini Karşılama</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Tesis bölge dışında yeterince tanınmadığı için ayın tamamı <strong>tanınırlık kurmaya</strong> ayrıldı: doğal kayalık havuzun
              kendisi en güçlü kreatif malzeme, bu yüzden Meta tarafı <strong>Awareness + Engagement + Video Views</strong> üçlüsüne
              indirgendi. <strong>Meta'da trafik ve mesaj kampanyası yok</strong> — ilgi henüz oluşmamışken tıklama satın almak
              düşük niyetli ve pahalı trafik üretir. Buna karşılık Google tarafında <strong>Search geri geldi</strong>: bilinirlik arttıkça
              markayı ve "bursa kaplıca" tipi terimleri arayan kullanıcı çoğalır, onlar karşılanmalıdır.
              Kısacası mantık şu: <strong>talebi Meta ve video yaratır, oluşan talebi Google Search toplar.</strong>
            </p>
          </div>

          {/* AMAÇ BAZLI BÜTÇE DAĞILIMI */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya Amacına Göre Bütçe Dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-red-400" style={{ width: '68.6%' }} title="Farkındalık %69" />
                <div className="bg-pink-400" style={{ width: '17.1%' }} title="Etkileşim %17" />
                <div className="bg-sky-400" style={{ width: '14.3%' }} title="Trafik %14" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Ana Mecralar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen Çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺48,000</td>
                    <td className="px-4 py-2.5 text-right">69%</td>
                    <td className="px-4 py-2.5">Meta Awareness (2 bölge) + Video Views · Google YouTube · TikTok Video Views</td>
                    <td className="px-4 py-2.5">340,000 izlenme · 1.72M gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺12,000</td>
                    <td className="px-4 py-2.5 text-right">17%</td>
                    <td className="px-4 py-2.5">Meta Etkileşim (doğal havuz / manzara içerikleri)</td>
                    <td className="px-4 py-2.5">30,000 etkileşim · 300K gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Trafik" not="niyetli arama" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺10,000</td>
                    <td className="px-4 py-2.5 text-right">14%</td>
                    <td className="px-4 py-2.5">Google Search — Brand + Generic</td>
                    <td className="px-4 py-2.5">3,056 tıklama · ort. ₺3.27 CPC</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺70,000</td>
                    <td className="px-4 py-2.5 text-right">100%</td>
                    <td className="px-4 py-2.5">3 mecra · 7 kampanya</td>
                    <td className="px-4 py-2.5">3,056 tıklama · 340K izlenme · 30K etkileşim · 2.06M gösterim</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-teal-50 border-t border-teal-100 text-[11px] text-teal-800">
              <strong>Dönüşüm ve mesaj satırı bilinçli olarak yok.</strong> Günübirlik tesiste satın alma online gerçekleşmez, dolayısıyla
              reklam platformları "dönüşüm" göremez. Bütçenin %86'sı bilinirlik ve etkileşime, %14'ü ise
              <strong> zaten niyet taşıyan arama trafiğine</strong> ayrıldı. Meta'da trafik satın alınmıyor: tanınmayan bir tesise
              soğuk kitleden tıklama almak pahalı ve düşük nitelikli olur — tıklama, arama tarafında toplanır.
            </div>
          </div>

          {/* Mecra Özeti */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺38,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">54% • Awareness + Engagement + Video Views</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺29,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">41% • YouTube ₺19K + Search ₺10K</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺3,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">4% • test bütçesi • Video Views</p>
            </div>
            <div className="rounded-xl border border-teal-100 bg-teal-50 p-4">
              <span className="text-xs font-medium text-teal-700">Toplam İzlenme</span>
              <p className="text-xl font-bold text-teal-800">340K</p>
              <p className="text-[10px] text-teal-600 mt-0.5">Meta 100K + YouTube 190K + TikTok 50K</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Tahmini Erişim*</span>
              <p className="text-xl font-bold text-gray-800">~900K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">2.06M gösterim · ort. frekans ~2.3</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı — KERAMET ILICASI Ağustos 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Awareness — Yakın Çevre</td>
                    <td className="px-4 py-3">Bursa · Yalova · Orhangazi · İznik · Gemlik (0-60 km) · 25-60 yaş · aile ve arkadaş grubu</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">400,000 gösterim · ~270,000 erişim · ₺25 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺10,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Awareness — Hafta Sonu Kaçamağı</td>
                    <td className="px-4 py-3">İstanbul (Anadolu yakası öncelikli) · Kocaeli · Sakarya (60-150 km) · doğa, kamp, termal ilgi alanları</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">267,000 gösterim · ~178,000 erişim · ₺30 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement (doğal havuz / manzara içerikleri)</td>
                    <td className="px-4 py-3">Bölgesel geniş kitle 0-150 km · doğa, gezi, fotoğrafçılık ilgi alanları + video izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">300,000 gösterim · 30,000 etkileşim · ₺0.40 CPE</td>
                    <td className="px-4 py-3 text-right font-medium">₺12,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Video Views (tanıtım filmi)</td>
                    <td className="px-4 py-3">Bölgesel geniş prospecting 0-150 km · 25-55 yaş</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">320,000 gösterim · 100,000 izlenme · ₺0.08 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">1,287,000 gösterim · 100K izlenme · 30K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺38,000</td>
                  </tr>

                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                        <span>YouTube Video</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">0-150 km yarıçap · doğa, gezi, termal ilgi alanları + yerel gezi kanalı yerleşimleri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">613,000 gösterim · 190,000 izlenme · ₺0.10 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺19,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Brand</td>
                    <td className="px-4 py-3">"keramet ılıcası", "keramet kaplıcası", "keramet köyü havuz" arayanlar</td>
                    <td className="px-4 py-3"><Amac tip="Trafik" not="niyetli" /></td>
                    <td className="px-4 py-3">7,000 gösterim · 1,500 tıklama · ₺2.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺3,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Generic</td>
                    <td className="px-4 py-3">"bursa kaplıca", "termal havuz", "doğal sıcak su havuzu", "günübirlik termal" arayanlar · bölgesel kısıt</td>
                    <td className="px-4 py-3"><Amac tip="Trafik" not="niyetli" /></td>
                    <td className="px-4 py-3">34,000 gösterim · 1,556 tıklama · ₺4.5 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads Toplam</td>
                    <td className="px-4 py-3">654,000 gösterim · 3,056 tıklama · 190K izlenme</td>
                    <td className="px-4 py-3 text-right">₺29,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top">
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Video Views (doğal havuz · drone · "gizli kalmış yer")</td>
                    <td className="px-4 py-3">18-45 yaş · bölgesel · gezi, keşif, doğa içeriği izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">120,000 gösterim · 50,000 izlenme · ₺25 CPM · ₺0.06 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺3,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads Toplam</td>
                    <td className="px-4 py-3">120,000 gösterim · 50,000 izlenme</td>
                    <td className="px-4 py-3 text-right">₺3,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3">2,061,000 gösterim · 3,056 tıklama · 340K izlenme · 30K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺70,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Kanal kararı */}
          <div className="mb-8 p-4 rounded-xl bg-slate-50 border border-slate-200">
            <p className="text-xs font-semibold text-gray-800 mb-1">Neden Meta'da Trafik/Mesaj Yok, Google'da Search Var?</p>
            <p className="text-[11px] text-gray-600 leading-relaxed">
              İki karar aynı mantıktan geliyor: <strong>tanınmayan bir tesiste tıklama satın almak yerine önce tanınırlık kurulur.</strong>{' '}
              Meta'da soğuk kitleye trafik veya mesaj kampanyası açmak, ilgisi henüz oluşmamış kullanıcıdan pahalı ve niteliksiz
              tıklama üretir. Bu yüzden Meta tarafı yalnızca <strong>Awareness, Engagement ve Video Views</strong> ile çalışıyor —
              hepsi CPM/CPV bazlı, yani birim maliyeti düşük ve erişimi geniş.
              Buna karşılık <strong>Google Search geri getirildi (₺10.000)</strong>: video ve bilinirlik kampanyaları çalışmaya başladıkça
              markayı adıyla ve "bursa kaplıca" tipi terimlerle arayan kullanıcı sayısı artar; bu trafiğin <strong>niyeti zaten mevcuttur</strong>{' '}
              ve karşılanmadığı takdirde doğrudan rakip tesislere gider. Brand tarafı (₺3.000) en ucuz ve en yüksek niyetli kalemdir;
              Generic (₺7.000) ise kategoriye yeni giren kullanıcıyı yakalar.
            </p>
          </div>

          {/* Yayın takvimi */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Yayın Takvimi</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-red-200 bg-red-50/50 p-3">
                <p className="font-semibold text-red-800 mb-1">Awareness + Video Views — sürekli akan %69 (₺48K)</p>
                <p className="leading-relaxed">Meta Awareness/Video Views, YouTube ve TikTok gün/saat kısıtı olmadan tüm ay akar. Amaç anlık ziyaret değil, erişim ve izlenme tabanını düzenli büyütmek.</p>
              </div>
              <div className="rounded-lg border border-pink-200 bg-pink-50/50 p-3">
                <p className="font-semibold text-pink-800 mb-1">Engagement — Perşembe-Pazar ağırlıklı %17 (₺12K)</p>
                <p className="leading-relaxed">Günübirlik ziyaretin yoğunlaştığı pencerede etkileşim içerikleri öne çıkarılır; hafta sonu planı yapan kullanıcı içerikle bu günlerde karşılaşır.</p>
              </div>
              <div className="rounded-lg border border-sky-200 bg-sky-50/50 p-3">
                <p className="font-semibold text-sky-800 mb-1">Search — sürekli akan %14 (₺10K)</p>
                <p className="leading-relaxed">Brand ve Generic kampanyaları gün/saat kısıtı olmadan açık kalır; adı arayan ve yol tarifi isteyen kullanıcı her zaman karşılanmalıdır.</p>
              </div>
            </div>
          </div>

          {/* Ölçümleme ön koşulları */}
          <div className="rounded-xl border border-orange-200 overflow-hidden mb-8">
            <div className="bg-orange-50 px-4 py-3 font-semibold text-orange-900 text-sm">Ölçümleme Ön Koşulları — Yayın Öncesi Tamamlanmalı</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Ziyaret ölçülemez — vekil metrikler şart</p>
                <p className="leading-relaxed">
                  Günübirlik tesiste satın alma online gerçekleşmediği için reklam platformları ziyareti göremez. Ölçümün dayanacağı üç vekil metrik:
                  <strong> (1)</strong> Google Business Profile "yol tarifi al" tıklaması, <strong>(2)</strong> site üzerinden telefon tıklaması,
                  <strong> (3)</strong> Search kampanyalarının getirdiği site oturumu ve sayfa derinliği. Bu üçü kurulmadan hiçbir kampanya
                  dönüşüme optimize edilemez.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Kurulum listesi</p>
                <p className="leading-relaxed">
                  <strong>Google Business Profile'ın doğrulanması ve Google Ads'e bağlanması</strong> · GA4 mülkü + Google Ads bağlantısı ·
                  Meta Pixel + Conversions API · YouTube kanalının Google Ads hesabına bağlanması · TikTok Business hesabı.
                  Kurulum tamamlanmadan başlanırsa Ağustos yalnızca <strong>erişim, izlenme, etkileşim ve tıklama</strong> düzeyinde
                  raporlanabilir; maliyet/ziyaret hesaplanamaz.
                </p>
              </div>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme &amp; Strateji</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-teal-100 bg-teal-50/40 p-3">
                <p className="font-semibold text-teal-800 mb-1">Yakın Çevre (0-60 km)</p>
                <p className="leading-relaxed">Bursa, Yalova, Orhangazi, İznik, Gemlik. 25-60 yaş, aile ve arkadaş grubu. Mesaj: "yarım saatlik yolda doğal termal havuz". Erişim maliyeti en düşük, tekrarlayan ziyaret potansiyeli en yüksek grup — Awareness bütçesinin büyük payı burada.</p>
              </div>
              <div className="rounded-lg border border-sky-100 bg-sky-50/40 p-3">
                <p className="font-semibold text-sky-800 mb-1">Hafta Sonu Kaçamağı (60-150 km)</p>
                <p className="leading-relaxed">İstanbul (Anadolu yakası öncelikli), Kocaeli, Sakarya. Doğa/kamp/termal ilgi alanları. Ayrı kampanya olarak kurulur ki iki bölgenin erişim maliyeti <strong>ayrı ayrı ölçülebilsin</strong> — ilk ayın asıl çıktısı bu karşılaştırma.</p>
              </div>
              <div className="rounded-lg border border-red-100 bg-red-50/40 p-3">
                <p className="font-semibold text-red-800 mb-1">Video Kanalları (YouTube + TikTok)</p>
                <p className="leading-relaxed">Toplam <strong>240K izlenme</strong> hedefi. YouTube'da bölgesel yarıçap + doğa/gezi/termal ilgi alanı; TikTok'ta "gizli kalmış yer / doğal havuz" formatı — organik yayılma potansiyeli de taşır. <strong>TikTok bu ay ₺3K test</strong>; birim maliyeti ölçülürse Eylül'de büyütülür.</p>
              </div>
              <div className="rounded-lg border border-violet-100 bg-violet-50/40 p-3">
                <p className="font-semibold text-violet-800 mb-1">Sonbahar Havuzu Kurma</p>
                <p className="leading-relaxed">Termal suyun asıl sezonu serin aylardır. Ağustos'ta biriken izleyici ve etkileşim havuzu, Ekim-Şubat döneminde ucuz retargeting kaynağı olarak kullanılmak üzere şimdiden toplanır — bu ayın en kalıcı çıktısı budur.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plandaki <strong>tüm birim maliyetler pazar benchmark'ıdır</strong>; Keramet Ilıcası hesabının kendi geçmiş verisi bulunmadığı için
                  hiçbir rakam gerçekleşen performanstan türetilmemiştir. Ziyaret, ciro veya ziyaret başı maliyet projeksiyonu bilinçli olarak verilmemiştir —
                  günübirlik tesiste bu metrikler reklam platformlarından ölçülemez.
                  Bütçenin <strong>%86'sı bilinirlik ve etkileşime</strong> ayrıldığı için bu ay tıklama sayısı düşük görünür (3,056 — tamamı Google Search'ten);
                  bu bir performans kaybı değil, bilinçli bir huni tercihidir. Ölçülecek şey tıklama değil, <strong>erişim ve izlenme havuzunun büyüklüğü ile birim maliyeti</strong>.
                  TikTok ₺3,000 ile <strong>test seviyesindedir</strong> (Video Views · ₺25 CPM benchmark); trafik kampanyası yoktur. <strong>*Tahmini erişim</strong> platform içi tekilleştirmedir; mecralar arası çakışma ölçülemez.
                  Tesis künyesi kamuya açık kaynaklardan derlenmiştir ve işletme tarafından doğrulanmalıdır.
                  Ay sonunda gerçekleşen CPM/CPV/CPC değerleriyle bu plan yeniden kalibre edilecektir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
